import styled, { css } from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 65vh;
  width: 60vw;
  user-select: none;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const TabBar = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
  width: 100%;
  & button {
    min-width: auto;
    width: auto;
    border-radius: 0;
    flex: 1;
    &:first-of-type {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-of-type {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
`;

const sizeLimitColor = (limit: number, size: number, theme: Record<string, string>) => {
  if (size > limit) return theme.error;
  if (size === limit) return theme.warning;
  return theme.success;
};

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
`;

export const ToolbarContainer = styled.div<{limit: number, size: number}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  & > span {
    font-size: 12px;
    color: ${({ theme, limit, size }) => sizeLimitColor(limit, size, theme)};
  }
  & button {
    height: 26px;
    & svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const KpisContainer = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: repeat(2, minmax(0, 1fr));;
  grid-gap: 10px;
  height: 100%;
  align-content: flex-start;
  overflow: hidden auto;
  padding: 5px;
  background-color: ${({ theme }) => theme.containerOdd};
  box-sizing: border-box;
  & > div {
    cursor: default;
  }
  @media ${devices.phoneL} {
    grid-template-columns: 1fr;
  }
`;

export const KpiContainerEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 30px;
  background-color: ${({ theme }) => theme.containerOdd};
  & > span {
    font-size: 14px;
    margin-bottom: 20px;
    color: ${({ theme }) => theme.grey};
    grid-column: span 2;
    text-align: center;
  }
  & > div {
    display: flex;
    flex-direction: row;
    & > span {
      margin: auto 10px;
      font-size: 14px;
      color: ${({ theme }) => theme.grey};
    }
  }
  & button {
    height: 50px;
    & svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const KpiCard = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  border: 2px solid;
  box-sizing: border-box;
  ${({ theme }) => css`
    background-color: ${theme.container};
    border-color: ${theme.container};
    &.assistant-mark {
      background: repeating-linear-gradient(
        45deg,
        ${theme.container},
        ${theme.container} 10px,
        ${theme.container}88 10px,
        ${theme.container}88 20px
      )
    }
  `}
`;

export const KpiCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  & > h5 {
    font-size: 14px;
    margin: 0 0 4px 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  & > div.action-group {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    & > div:first-child {
      margin-right: 5px;
    }
  }
`;

export const KpiCardIcon = styled.div`
  display: flex;
  aspect-ratio: 1;
  width: 70px;
  max-width: 70px;
  margin-right: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & svg  {
    height: 100%;
    width: 100%;
  }
  & span {
    margin-top: 2px;
    font-size: 10px;
  }
`;

export const KpiCardContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  position: relative;
  & span, span b {
    font-size: 12px;
  }
  & > span + span {
    margin-top: 2px;
  }
`;

export const CardAssistantBadge = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  & > div {
    cursor: default;
  }
  & svg {
    height: 20px;
    width: 20px;
    fill: #EFBF04;
  }
`;
